import React from 'react';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import TpClientInvoiceLineitemUpsertItem from '../../../../Domain/TpClientInvoiceLineItemUpsertItem';
import TpClientInvoiceLineItemService from '../../../../Services/TpClientInvoiceLineItemService';

export default class UpsertTpClientInvoiceLineItemWindowDescription extends React.Component {
  static titleForCreate = 'Create Line Item';
  static titleForEdit = 'Edit Line Item';
  static itemType = TpClientInvoiceLineitemUpsertItem;
  static serviceFunction = (edited) => TpClientInvoiceLineItemService.Upsert(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'TpClientInvoiceId',
          label: 'Client Invoice',
          className: 'col-4',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Total',
          label: 'Client Fee',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        {
          fieldName: (item) => item.CurrencyId,
          label: 'Currency',
          className: 'col-4',
          type: InputTypesEnum.ActiveCurrencySelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          showFilterAt: 500,
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        // The two type fields take half a row each so their labels are not truncated. Filling row
        // two also pushes 'Item Tied To' onto the next row, at its left edge.
        {
          fieldName: 'TypeLookupItemValue',
          label: 'Type',
          className: 'col-12',
          type: InputTypesEnum.ClientLineTypeLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          disabled: (item) => item.IsInvoiceFinalized === true,
          // Changing the Type re-seeds the internal type with the same value. It is a copy on
          // change, not a mirror: the user is free to pick a different internal type afterwards
          // and it stays until Type is changed again.
          onFieldChange: UpsertTpClientInvoiceLineItemWindowDescription.copyTypeToInternalType,
        },
        {
          fieldName: 'InternalLineItemTypeLookupValue',
          label: 'Internal Type',
          className: 'col-12',
          type: InputTypesEnum.ClientLineTypeLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        // Row three: 'Item Tied To' next to whichever of Project / Service it selected - they are
        // mutually exclusive, so exactly one of them is ever visible and the row holds two fields.
        {
          fieldName: 'TiedToType',
          label: 'Item Tied To:',
          className: 'col-6',
          type: InputTypesEnum.Select,
          validityChecker: UpsertTpClientInvoiceLineItemWindowDescription.validateTiedToType,
          selectvalues: UpsertTpClientInvoiceLineItemWindowDescription.getTiedToOptions(),
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        {
          fieldName: 'ProjectId',
          label: 'Project',
          className: 'col-6',
          type: InputTypesEnum.ActiveProjectSelect,
          validityChecker: UpsertTpClientInvoiceLineItemWindowDescription.validateProjectSelect,
          idFilter: 'CaspianClientId',
          hide: (item) => item.TiedToType !== 'Project',
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        {
          fieldName: 'ServiceId',
          label: 'Service',
          className: 'col-6',
          type: InputTypesEnum.ActiveServiceSelect,
          validityChecker: UpsertTpClientInvoiceLineItemWindowDescription.validateServiceSelect,
          idFilter: 'CaspianClientId',
          hide: (item) => item.TiedToType !== 'Service',
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
        {
          fieldName: 'Description',
          label: 'Description',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 200),
          disabled: (item) => item.IsInvoiceFinalized === true,
        },
      ],
    },
  ];

  // Mutating the edited item is how the wizard's onFieldChange hook reaches a field other than
  // the one that was edited; returning nothing leaves Type itself as the user set it.
  static copyTypeToInternalType(item) {
    item.InternalLineItemTypeLookupValue = item.TypeLookupItemValue;
  }

  static getTiedToOptions() {
    return selectHelper.generateSelectValues(['', 'Project', 'Service']);
  }

  static validateTiedToType(e, item) {
    if (item.ProjectId || item.ServiceId) {
      return '';
    }
    return ValidityHelper.forRequiredSelectField(e, item);
  }

  static validateProjectSelect(e, item) {
    if (item.TiedToType === 'Project') {
      return ValidityHelper.forRequiredSelectField(e, item);
    }
    return '';
  }

  static validateServiceSelect(e, item) {
    if (item.TiedToType === 'Service') {
      return ValidityHelper.forRequiredSelectField(e, item);
    }
    return '';
  }
}
